"use client";

import { useEffect } from "react";

/**
 * Global error boundary (Next.js App Router). It replaces the **root layout**
 * when an error escapes it, so it must render its own `<html>`/`<body>` and stay
 * fully self-contained — no app providers, Redux, theme, or `C*` components
 * (their React context isn't available here, which is what broke the prerender of
 * Next's auto-generated `_global-error`). Plain inline styles only.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
          background: "#f8fafc",
          color: "#0f172a",
        }}
      >
        <div style={{ textAlign: "center", padding: 24, maxWidth: 420 }}>
          <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>
            Something went wrong
          </h1>
          <p style={{ color: "#64748b", marginTop: 8, lineHeight: 1.5 }}>
            An unexpected error occurred. Please try again.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: 16,
              padding: "8px 18px",
              borderRadius: 8,
              border: "none",
              background: "#335cff",
              color: "#fff",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
